import { Incident } from '../Types/Incident';
import { parseUtc } from './dateHelpers';

/**
 * Extract the start timestamp (in epoch ms) from an incident.
 * Returns NaN if the field is missing or unparseable.
 */
export function parseIncidentStart(incident: Incident): number {
  if (!incident.startedAtUtc) return NaN;
  return parseUtc(incident.startedAtUtc).getTime();
}

/**
 * Format the elapsed time between `startMs` and `nowMs` as HH:MM:SS.
 * Hours are not capped at 24 (e.g. 27:18:44).
 * Negative elapsed time is clamped to 00:00:00.
 */
export function formatElapsedHms(startMs: number, nowMs: number): string {
  const diffMs = Math.max(0, nowMs - startMs);
  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}
